import type { IdTokenClaims } from 'oidc-client-ts';

/// Los talleres que trae el token de quien entró (#205): el claim `tenant_ids`,
/// que Keycloak firma y que el worker escribe a partir de sus membresías.
///
/// Viaja en el **id token**: el scope `tallerya-tenant` del realm lo pone en los
/// dos tokens, y el navegador solo debería abrir este.
///
/// Cuenta como taller lo mismo que cuenta la API: un UUID (`TenantId.TryParse`).
/// Un valor cargado mal a mano en Keycloak se descarta acá, en vez de ofrecer un
/// taller al que la API le respondería 403 a todo.
export function talleresDelToken(perfil: IdTokenClaims | undefined): string[] {
  const talleres = perfil?.['tenant_ids'];

  // Keycloak lo escribe como arreglo aunque haya uno solo. Se acepta también el
  // texto suelto, por si alguna vez el mapeador se configura sin «multivalued».
  const lista = Array.isArray(talleres) ? talleres : typeof talleres === 'string' ? [talleres] : [];

  return lista.filter((t): t is string => typeof t === 'string' && UUID.test(t.trim())).map((t) => t.trim());
}

/// Si quien entró pertenece a algún taller (#168).
///
/// El admin es de un taller: sin talleres en el token, la API responde 403 a
/// todo. Pasa con los usuarios del equipo de TallerYa, como `plataforma.dev`: la
/// sesión de Keycloak es una sola para el admin y la consola, así que quien entró
/// a la consola llega al admin sin que le pidan contraseña. Y desde #205 pasa
/// también un rato con un dueño recién dado de alta, hasta que el worker le
/// escribe su lista.
///
/// **No es una barrera de seguridad**, esa es la API. Esto evita que la pantalla
/// se dibuje a medias —el menú sin destinos, el inicio vacío— sin explicar por qué.
export function esDeTaller(perfil: IdTokenClaims | undefined): boolean {
  return talleresDelToken(perfil).length > 0;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
